import { connect } from 'react-redux';
import React from 'react';
import { Form } from 'antd';
import * as valid from 'utils/validate';
import { KBFormError,
KBButton,
KBInput } from
'components';
import * as selectors from 'app/selectors';

const getChangeValue = value => (value && value.target ? value.target.value : value);

function FormField({ children, error, onChange, onClearError, touched, value }) {
  return children({
    value,
    touched,
    error,
    onChange: nextValue => {
      onChange(getChangeValue(nextValue));
      onClearError();
    }
  });
}

function LocationSetLockPermission({ error, locationLockSettings, updateLocationSetting }) {
  const [form] = Form.useForm();
  const [errors, setErrors] = React.useState({});
  const [submitting, setSubmitting] = React.useState(false);
  const initialValues = React.useMemo(
    () => getInitialValues(locationLockSettings),
    [locationLockSettings]
  );
  const initialValuesKey = JSON.stringify(initialValues);

  React.useEffect(() => {
    form.setFieldsValue(initialValues);
    setErrors({});
  }, [form, initialValuesKey]);

  const renderField = (name, render) => (
    <Form.Item name={name} noStyle>
      <FormField
        error={errors[name]}
        touched={!!errors[name]}
        onClearError={() =>
          setErrors(prevErrors => Object.assign({}, prevErrors, { [name]: undefined }))
        }
      >
        {render}
      </FormField>
    </Form.Item>
  );

  const handleFinish = () => {
    const formValues = form.getFieldsValue();
    const nextErrors = validate(formValues);
    if (Object.keys(nextErrors).some(name => !!nextErrors[name])) {
      setErrors(nextErrors);
      return;
    }

    setSubmitting(true);
    const result = updateLocationSetting(
      {
        lock_settings: formValues
      },
      {
        key: ['lock_settings']
      }
    );
    if (result && result.then) {
      return result.then(
        value => {
          setSubmitting(false);
          return value;
        },
        requestError => {
          setSubmitting(false);
          throw requestError;
        }
      );
    }
    setSubmitting(false);
    return result;
  };

  return (
    <div className="nav-section-content-container" style={{ padding: 0 }}>
      <header className="nav-header">
        <div className="nav-section-header-title">
          <span>门禁设置</span>
        </div>
      </header>
      <div className="kb-form-container">
        <Form form={form} initialValues={initialValues} onFinish={handleFinish}>
          <KBFormError error={error} />
          <div className="kb-form-container" style={{ padding: 0 }}>
            <div className="kb-row">
              {renderField('advance_assign_lock_permission_day', field => (
                <KBInput
                  className="kb-form-group kb-div-c48 kb-form-alone"
                  title="合同开始前多少天给予门禁权限和租户管理员添加员工的权限"
                  field={field}

                  type="number"
                />
              ))}
            </div>
            <div className="kb-row">
              {renderField('temporary_company_lock_permission_day', field => (
                <KBInput
                  className="kb-form-group kb-div-c48 kb-form-alone"
                  title="临时租户公司员工有效期(天)"
                  field={field}

                  type="number"
                />
              ))}
            </div>
            <div className="kb-row m-top">
              <KBButton className="certain-btn" type="submit" submitting={submitting}>
                保存
              </KBButton>
            </div>
          </div>
        </Form>
      </div>
    </div>
  );
}

function mapStateToProps(state, props) {
  const loc_id = props.params.id;
  const locationSetting = selectors.getLocationSetting(state, loc_id) || {};
  const lockSettings = locationSetting.lock_settings || {};
  const {
    advance_assign_lock_permission_day,
    temporary_company_lock_permission_day
  } = lockSettings;

  return {
    loc_id,
    locationLockSettings: {
      advance_assign_lock_permission_day,
      temporary_company_lock_permission_day
    }
  };
}

const validate = values => {
  const errors = {};
  const { advance_assign_lock_permission_day, temporary_company_lock_permission_day } = values;

  if (valid.required(advance_assign_lock_permission_day)) {
    errors.advance_assign_lock_permission_day = '请输入天数';
  } else if (
    valid.integer(advance_assign_lock_permission_day) ||
    advance_assign_lock_permission_day < 0
  ) {
    errors.advance_assign_lock_permission_day = '请输入正整数';
  }

  if (valid.required(temporary_company_lock_permission_day)) {
    errors.temporary_company_lock_permission_day = '请输入天数';
  } else if (
    valid.integer(temporary_company_lock_permission_day) ||
    temporary_company_lock_permission_day < 0
  ) {
    errors.temporary_company_lock_permission_day = '请输入正整数';
  }

  return errors;
};

const getInitialValues = (setting = {}) => ({
  advance_assign_lock_permission_day:
    setting && setting.advance_assign_lock_permission_day,
  temporary_company_lock_permission_day:
    setting && setting.temporary_company_lock_permission_day
});

export default connect(mapStateToProps)(LocationSetLockPermission);
